import { Action } from '@ngrx/store';
import { TimeWindow, Order } from '@cemex-core/cmx-api';

export enum OneClickTimeWindowsActionTypes {
  LOAD_TIME_WINDOWS = '[One Click] Load time windows',
  LOAD_TIME_WINDOWS_COMPLETE = '[One Click] Load time windows completed',
  SELECT_TIME_WINDOWS = '[One Click] Select time windows',
  RESET = '[One Click] time windows reset',
}

export class OneClickLoadTimeWindowsAction implements Action {
  readonly type = OneClickTimeWindowsActionTypes.LOAD_TIME_WINDOWS;

  constructor(public payload: Order) {}
}

export class OneClickLoadTimeWindowsCompleteAction implements Action {
  readonly type = OneClickTimeWindowsActionTypes.LOAD_TIME_WINDOWS_COMPLETE;

  constructor(public payload: TimeWindow[]) {}
}

export class OneClickSelectTimeWindowsAction implements Action {
  readonly type = OneClickTimeWindowsActionTypes.SELECT_TIME_WINDOWS;

  constructor(public payload: TimeWindow) {}
}

export class OneClickResetTimeWindowsAction implements Action {
  readonly type = OneClickTimeWindowsActionTypes.RESET;

  constructor() {}
}

export type OneClickTimeWindowsActions =
  | OneClickLoadTimeWindowsAction
  | OneClickLoadTimeWindowsCompleteAction
  | OneClickSelectTimeWindowsAction
  | OneClickResetTimeWindowsAction;
